import axios from 'axios';

const module = 'admin/chatbot-conversations';

const actions = {
  index: async (context, payload) => {
    const { page = 1, limit = 20 } = payload || {};
    return await axios.get(
      `${context.rootGetters['settings/getEndpoint']}api/v1/${module}?page=${page}&limit=${limit}`,
      { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
    ).then(res => res.data.result);
  },

  show: async (context, id) => {
    return await axios.get(
      `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/${id}`,
      { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
    ).then(res => res.data.result);
  }
};

export default { namespaced: true, actions };
